import { ApiBase } from '@fg-services/api/models/api-base';
import { HttpHeaders } from '@angular/common/http';

export class TixrConfigsApi extends ApiBase {
  model = 'TixrConfigs';

  getConfig(orgId: string, options?: { headers?: HttpHeaders | { [header: string]: string | string[] } }) {
    return this.http.get<any>(`${this.modelBase}/${orgId}`, options);
  }

  postConfig(orgId: string, body: any, options?: { headers?: HttpHeaders | { [header: string]: string | string[] } }) {
    return this.http.post<any>(`${this.modelBase}/${orgId}`, body, options);
  }

  patchConfig(orgId: string, body: any, options?: { headers?: HttpHeaders | { [header: string]: string | string[] } }) {
    return this.http.patch<any>(`${this.modelBase}/${orgId}`, body, options);
  }
}
